import React from 'react'
import { useShallow } from 'zustand/react/shallow'
import Button from '../../ui/button'
import { useNotificationSubscriptionStore } from '../../../stores/notification/notificationSubscriptionStore'

export const AlerteNonClient = ({ firmUuid }: { firmUuid: string }) => {
  const openNewClientNotificationSubscriptionModal =
    useNotificationSubscriptionStore(
      useShallow((state) => state.openNewClientNotificationSubscriptionModal),
    )

  return (
    <div
      role="alert"
      className="flex flex-col justify-center h-full p-4 border rounded-lg md:p-6 lg:p-8 border-lamacompta-blue gap-y-4 bg-very-light-blue md:col-span-2"
    >
      <p className="font-normal text-center text-night">
        Ce cabinet n&apos;est pas référencé sur Lamacompta.
      </p>
      <p className="font-normal text-center text-night">
        Ajoute-le à tes favoris pour être alerté lorsqu&apos;il sera référencé.
      </p>
      <div className="flex justify-center mt-4">
        <Button
          label="Alertez moi lorsqu'il sera référencé"
          color="primary"
          invert
          size="medium"
          onClick={() => openNewClientNotificationSubscriptionModal(firmUuid)}
        />
      </div>
    </div>
  )
}
